import { 
  LANGUAGE_CODES,
  LanguageCode,
  ItemTranslation,
  ItemTasteTranslation,
  ItemFeatureTranslation,
} from '../i18n'

export interface Item {
  name?: string                    // 日本語名
  id: number
  beanAmount?: number
  beanTypeIndex?: number
  machineButtonIndex?: number
  price?: number
  priceExcludingTax?: number
  disposalSeconds?: number
  cupType?: ItemCupType
  index?: number
  imageURL?: string
  imageFileName?: string
  thumbnailImageURL?: string
  thumbnailImageFileName?: string
  description?: string             // 日本語説明
  story?: string                   // 日本語ストーリー
  category?: ItemCategory
  tastes?: Taste[]
  features?: Feature[]
  matchItemParam?: MatchItemParam
  color?: string
  itemTranslations?: ItemTranslation[]  // 多言語翻訳データ
  brand_code?: string              // ブランドコード（admin権限のみ有効）
}

export type ItemCupType = ItemCupTypeHot | ItemCupTypeIce
type ItemCupTypeHot = 1
type ItemCupTypeIce = 2

export type ItemCategory = ItemCategoryHot | ItemCategoryIce | ItemCategoryHotLatte | ItemCategoryIceLatte | ItemCategoryHotMilk | ItemCategoryIceMilk
type ItemCategoryHot = "hot"
type ItemCategoryIce = "ice"
type ItemCategoryHotLatte = "hot_latte"
type ItemCategoryIceLatte = "ice_latte"
type ItemCategoryHotMilk = "hot_milk"
type ItemCategoryIceMilk = "ice_milk"

export interface Taste {
  value: number
  name?: string
  itemTasteTranslations?: ItemTasteTranslation[]
}

export interface Feature {
  id?: number                     // API仕様に合わせてid追加
  name?: string
  content?: string
  itemFeatureTranslations?: ItemFeatureTranslation[]
}

export interface MatchItemParam {
  bitterness: number
  fragrance: number
  acidity: number
  sweetness: number
  richness: number
  uniqueness: number
}

export enum ItemImageType {
  Image = 'image',
  ThumbnailImage = 'thumbnail_image',
}

export interface ItemImage {
  fileName?: string
  url?: string
  itemImageType?: ItemImageType
}


// デフォルトの言語コード
export const defaultLanguageCode: LanguageCode = LANGUAGE_CODES.JAPANESE
